import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SessionService } from '@core/auth';
import { canFollowPlanningTasks } from '@features/planning/util-planning-task';
import { PlanningTaskFacade } from './planning-task.facade';

/**
 * Mounted once in the shell (behind the auth guard): renders nothing and only
 * starts following the planning tasks, so a reload outside the planning still
 * tells the user how a finalize ended (#5182, PR 1785).
 */
@Component({
  selector: 'planning-task-observer',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanningTaskObserverComponent {
  constructor() {
    if (canFollowPlanningTasks(inject(SessionService))) {
      inject(PlanningTaskFacade);
    }
  }
}
